export default "__VITE_ASSET__gH_ht9kK__"